/* ============================================
   Customer Gallery — Lightbox
   Vanilla JS, no external libraries
   ============================================ */

(function () {
  'use strict';

  let cards = [];
  let currentIndex = 0;
  let overlay, lbImg, lbCustomer, lbInstagram, lbCaption, lbDate,
      lbProductName, lbShopBtn, lbShare, lbPrev, lbNext;
  let touchStartX = 0;
  let section;

  function getSection() {
    return document.querySelector('.customer-gallery');
  }

  function getSetting(key) {
    if (!section) return true;
    return section.dataset[key] !== 'false';
  }

  function buildLightbox() {
    overlay = document.createElement('div');
    overlay.className = 'cg-lightbox-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Customer photo viewer');

    overlay.innerHTML = `
      <button class="cg-lb-arrow cg-lb-arrow-prev" aria-label="Previous photo">&#8592;</button>
      <div class="cg-lightbox-inner">
        <div class="cg-lb-image-panel">
          <img src="" alt="" id="cg-lb-img" />
        </div>
        <div class="cg-lb-info-panel">
          <button class="cg-lb-close" aria-label="Close">&times;</button>
          <p class="cg-lb-customer" id="cg-lb-customer"></p>
          <a class="cg-lb-instagram" id="cg-lb-instagram" href="#" target="_blank" rel="noopener"></a>
          <p class="cg-lb-caption" id="cg-lb-caption"></p>
          <p class="cg-lb-date" id="cg-lb-date"></p>
          <p class="cg-lb-product-name" id="cg-lb-product-name"></p>
          <a class="cg-lb-shop-btn filled" id="cg-lb-shop-btn" href="#" target="_blank" rel="noopener"></a>
          <div class="cg-lb-share" id="cg-lb-share">
            <button class="cg-lb-share-btn" id="cg-lb-copy" aria-label="Copy link">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>
              Copy
            </button>
            <button class="cg-lb-share-btn" id="cg-lb-twitter" aria-label="Share on Twitter">
              <svg viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
              Tweet
            </button>
            <button class="cg-lb-share-btn" id="cg-lb-facebook" aria-label="Share on Facebook">
              <svg viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
              Share
            </button>
          </div>
        </div>
      </div>
      <button class="cg-lb-arrow cg-lb-arrow-next" aria-label="Next photo">&#8594;</button>
    `;
    const existing = document.querySelector('.cg-lightbox-overlay');
if (existing) {
    existing.remove();
}

    document.body.appendChild(overlay);

    overlay.style.display = 'none';

    lbImg = overlay.querySelector('#cg-lb-img');
    lbCustomer = overlay.querySelector('#cg-lb-customer');
    lbInstagram = overlay.querySelector('#cg-lb-instagram');
    lbCaption = overlay.querySelector('#cg-lb-caption');
    lbDate = overlay.querySelector('#cg-lb-date');
    lbProductName = overlay.querySelector('#cg-lb-product-name');
    lbShopBtn = overlay.querySelector('#cg-lb-shop-btn');
    lbShare = overlay.querySelector('#cg-lb-share');
    lbPrev = overlay.querySelector('.cg-lb-arrow-prev');
    lbNext = overlay.querySelector('.cg-lb-arrow-next');

    // Events
    overlay.querySelector('.cg-lb-close').addEventListener('click', closeLightbox);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeLightbox();
    });
    lbPrev.addEventListener('click', function (e) { e.stopPropagation(); navigate(-1); });
    lbNext.addEventListener('click', function (e) { e.stopPropagation(); navigate(1); });

    overlay.querySelector('#cg-lb-copy').addEventListener('click', function () {
      navigator.clipboard.writeText(window.location.href).then(function () {
        this.textContent = 'Copied!';
        setTimeout(() => { this.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg> Copy'; }, 2000);
      }.bind(this));
    });

    overlay.querySelector('#cg-lb-twitter').addEventListener('click', function () {
      window.open('https://twitter.com/intent/tweet?url=' + encodeURIComponent(window.location.href), '_blank');
    });

    overlay.querySelector('#cg-lb-facebook').addEventListener('click', function () {
      window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(window.location.href), '_blank');
    });

    // Touch swipe
    overlay.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
    overlay.addEventListener('touchend', function (e) {
      const diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) navigate(diff > 0 ? 1 : -1);
    });
  }

  function populateLightbox(index) {
    const card = cards[index];
    if (!card) return;

    const imgSrc = card.dataset.imageSrc || card.querySelector('img')?.src || '';
    const customer = card.dataset.customer || '';
    const instagram = card.dataset.instagram || '';
    const caption = card.dataset.caption || '';
    const date = card.dataset.date || '';
    const productTitle = card.dataset.productTitle || '';
    const productUrl = card.dataset.productUrl || '';
    const buttonText = card.dataset.buttonText || 'Shop This Product';

    // Crossfade image
    lbImg.style.opacity = '0';
    setTimeout(function () {
      lbImg.src = imgSrc;
      lbImg.alt = customer || 'Customer photo';
      lbImg.style.opacity = '1';
    }, 150);

    lbCustomer.textContent = customer;
    lbCustomer.style.display = customer ? '' : 'none';

    lbInstagram.textContent = instagram;
    lbInstagram.href = instagram ? 'https://instagram.com/' + instagram.replace('@', '') : '#';
    lbInstagram.style.display = instagram ? '' : 'none';

    lbCaption.textContent = caption;
    lbCaption.style.display = caption ? '' : 'none';

    lbDate.textContent = date;
    lbDate.style.display = date ? '' : 'none';

    lbProductName.textContent = productTitle;
    lbProductName.style.display = productTitle ? '' : 'none';

    const showBtn = section && section.dataset.showProductButton !== 'false';
    if (productUrl && showBtn) {
      lbShopBtn.href = productUrl;
      lbShopBtn.textContent = buttonText;
      lbShopBtn.style.display = '';
      const style = section ? section.dataset.buttonStyle || 'filled' : 'filled';
      lbShopBtn.className = 'cg-lb-shop-btn ' + style;
    } else {
      lbShopBtn.style.display = 'none';
    }

    const showShare = section && section.dataset.showShare !== 'false';
    lbShare.style.display = showShare ? '' : 'none';

    const showArrows = section && section.dataset.showArrows !== 'false';
    lbPrev.style.display = showArrows ? '' : 'none';
    lbNext.style.display = showArrows ? '' : 'none';
  }

 function openLightbox(index) {
    currentIndex = index;

    populateLightbox(currentIndex);

    overlay.style.display = 'flex';

    requestAnimationFrame(function () {
        overlay.classList.add('is-open');
    });

    document.body.style.overflow = 'hidden';

    overlay.querySelector('.cg-lb-close').focus();
}

  function closeLightbox() {
    overlay.classList.remove('is-open');
    setTimeout(function () {
      overlay.style.display = 'none';
      document.body.style.overflow = '';
    }, 300);
  }

  function navigate(dir) {
    currentIndex = (currentIndex + dir + cards.length) % cards.length;
    populateLightbox(currentIndex);
  }

  function init() {
    section = document.querySelector('.customer-gallery');
    cards = Array.from(document.querySelectorAll('.cg-card'));
    if (!cards.length) return;

    buildLightbox();

    cards.forEach(function (card, i) {
      card.addEventListener('click', function () { openLightbox(i); });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(i); }
      });
    });

    document.addEventListener('keydown', function (e) {
      if (!overlay || !overlay.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') navigate(-1);
      if (e.key === 'ArrowRight') navigate(1);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
